import React, { useContext } from "react";
import Flex from "../../components/structure/Flex";
import Button from "../../components/ui/Button";
import { AuthContext } from "../../contexts/auth";

interface UnAuthorisedPageProps {}

const UnAuthorisedPage: React.FC<UnAuthorisedPageProps> = () => {
  const { logout } = useContext(AuthContext);

  return (
    <Flex
      items="center"
      justify="center"
      className="w-screen min-h-screen bg-accent max-w-full text-dark"
    >
      <Flex
        items="center"
        col
        className="w-108 -mt-20 bg-light shadow-xs p-4 rounded-lg"
      >
        <h1 className="font-black text-orange text-3xl">Unauthorised</h1>
        <p className="text-center text-text mt-4">
          You are not authorised to use this app.
          <br />
          Contact <strong>Zo Admin</strong> for your access.
        </p>
        <div className="my-4">
          <Button size="lg" onClick={logout}>
            Log Out
          </Button>
        </div>
      </Flex>
    </Flex>
  );
};

export default UnAuthorisedPage;
